import { Component, inject, signal } from '@angular/core';
import { UiModule } from '@components/ui/ui-module';
import { PaymentMethod } from '../payment/payment-method/payment-method';
import { RouterModule } from '@angular/router';
import { Router } from '@services/route.service';
import { OrderService } from '@services/order.service';

@Component({
  selector: 'lgb-plan-payment',
  imports: [
    RouterModule,
    UiModule,
    PaymentMethod
  ],
  templateUrl: './plan-payment.html',
  styleUrl: './plan-payment.css',
})
export class PlanPayment {
  //services
  readonly router=inject(Router);
  readonly orderS=inject(OrderService);

  readonly loading=signal(false);
}
